import React, { useEffect, useState } from 'react';
import { BlockStack, Button, ButtonGroup, ChoiceList, Icon, Modal, Text, TextField } from '@shopify/polaris';
import { ArrowRightIcon, CheckCircleIcon, HeartIcon, ImageIcon, WandIcon } from "@shopify/polaris-icons";
import '../index/index.scss';
import Language from '../../../../i18n/Language';
import { showNewMessage } from '@intercom/messenger-js-sdk';
import SearchResource from '../../../../assets/SearchResource';
const t = Language;

const DowngradeRetain = (props) => {
    const {
        openState,
        disBtnLoading,
        paidLoading,
        downgradeType,
        downgradeLevel,
        isShowFeedback,
        downDataCompare,
        coupon_claimed,

    } = props;

    const [selectVal, setSelectVal] = useState([]);
    const [otherVal, setOtherVal] = useState('');
    const [otherValError, setOtherValError] = useState(false);
    const [continueVal, setContinueVal] = useState('');
    const [feedbackVal, setFeedbackVal] = useState('');
    const [prevDowngradeType, setPrevDowngradeType] = useState(downgradeType);
    const [showFeedback, setShowFeedback] = useState(isShowFeedback);

    // 弹窗关闭时清空内部选择
    useEffect(() => {
        if (!openState) {
            setContinueVal('');
        }
    }, [openState]);

    useEffect(() => {
        setPrevDowngradeType(downgradeType);
    }, [downgradeType]);

    useEffect(() => {
        setShowFeedback(isShowFeedback);
    }, [isShowFeedback]);

    // 关闭See you modal
    const handleCloseSeeyouModal = (andView = false) => {
        let _type = continueVal || selectVal[0];
        props.closeSeeyouModal && props.closeSeeyouModal(_type, _type === 'other' ? otherVal : '');

        if (andView) {
            handleCloseInfoViewModal();
        }
    }

    // 关闭 反馈 弹窗
    const handleCloseFeedModal = () => {
        if (disBtnLoading || paidLoading) {
            return;
        }
        setContinueVal('');
        handleCloseSeeyouModal();
    }

    // 关闭 信息查看 弹窗
    const handleCloseInfoViewModal = () => {
        setContinueVal('');
        setShowFeedback(false);
        props.closeInfoViewModal && props.closeInfoViewModal();
        handleCloseSeeyouModal();
    }

    // 取消订阅
    const handleCancelAnyway = () => {
        let _sel = continueVal || selectVal[0];
        props.downgradeAnyway && props.downgradeAnyway(_sel, _sel === 'other' ? otherVal : '');
    }

    // 应用折扣码
    const handleApplyDiscountCode = () => {
        let _sel = continueVal || selectVal[0];
        props.applyDiscountCode && props.applyDiscountCode(_sel, _sel === 'other' ? otherVal : '');
    }

    // 根据用户选择路由到对应挽留弹窗
    const handleContinueToCancel = () => {
        if (selectVal.length === 0) {
            return;
        } else if (['expensive', 'other'].includes(selectVal[0]) && Boolean(coupon_claimed)) {
            // 直接执行降级
            if (selectVal[0] === 'other' && !otherVal) {
                setOtherValError(true);
            } else {
                props.downgradeAnyway && props.downgradeAnyway(selectVal[0], selectVal[0] === 'other' ? otherVal : '');
            }
        } else {
            if (selectVal[0] === 'longer') {
                setShowFeedback(true);
                setPrevDowngradeType('longer');
            } else if (selectVal[0] === 'other' && !otherVal) {
                setOtherValError(true);
            } else {
                setContinueVal(selectVal[0]);
            }
        }
    }

    // 联系客服
    const handleContactUs = () => {
        const typeText = {
            "results": "Hi, I'm not seeing results with my SEO. Before I cancel, can you help me understand what's wrong and what I should do?",
            "features": "Hi, I'm considering cancelling because I couldn't find this feature: [feature request]. Is there a workaround or a plan to support it?",
            "alternative": "Hi, I'm considering switching to another SEO tool. Before I do, could you help review my site and show what I should fix?",
            "mistake": "Hi, I think I was charged by mistake. Could you help me check this and advise on a possible refund?",
            "difficult": "Hi, I'm thinking of cancelling because the setup feels too complicated. Is there someone who can help me get everything set up?",
        }
        showNewMessage(typeText[continueVal]);

        // 关闭弹窗
        handleCloseSeeyouModal();
    }

    // 输入框变化
    const handleInputChange = (value) => {
        setOtherVal(value);
        setOtherValError(false);
    }

    // 发送反馈
    const handleSendSuggestion = () => {
        handleCloseSeeyouModal(true);
        if (props.sendSuggestionAction && feedbackVal) {
            props.sendSuggestionAction(downgradeType, feedbackVal);
        }
    }

    // 确认切换到免费计划 (longer 路径)
    const handleConfirmSwitchToFree = () => {
        props.downgradeAnyway && props.downgradeAnyway('longer', feedbackVal);
    }

    // 免费计划权益列表
    const freePlanBenefits = [
        {
            icon: ImageIcon,
            title: t("Image Compressions"),
            subtitle: t("{{v1}} images to optimize", downDataCompare?.un_opt_num),
            oldVal: downgradeLevel === 3 ? '6,000' : '2,000',
            oldUnit: t("Per/mo"),
            newVal: '50',
            newUnit: t("Images"),
        },
        {
            icon: SearchResource,
            title: t("On-page SEO Audit"),
            subtitle: t("{{v1}} pages to optimize", downDataCompare?.pages_audited),
            oldVal: downgradeLevel === 3 ? t("Unlimited") : '1,000',
            oldUnit: t("pages"),
            newVal: '20',
            newUnit: t("Pages"),
        },
        {
            icon: WandIcon,
            title: t("AI Credit"),
            subtitle: '',
            oldVal: downgradeLevel === 3 ? '500' : '200',
            oldUnit: t("credits/mo"),
            newVal: '30',
            newUnit: t("Credits"),
        },
    ];

    const isLongerDowngrade = prevDowngradeType === 'longer';

    // 降级反馈弹窗
    const downgradeFeedbackModal = <Modal
        open={showFeedback}
        title={isLongerDowngrade ? t("Switch to Free Plan?") : t("You're all set on the free plan")}
        onClose={handleCloseInfoViewModal}
        primaryAction={
            isLongerDowngrade
                ? {
                    content: t("Switch to free plan"),
                    onAction: handleConfirmSwitchToFree,
                    disabled: paidLoading,
                    loading: paidLoading,
                }
                : {
                    content: t("Got it"),
                    onAction: handleSendSuggestion,
                }
        }
        secondaryActions={
            isLongerDowngrade
                ? [{
                    content: t("Keep my subscription"),
                    onAction: handleSendSuggestion,
                    disabled: paidLoading,
                }]
                : undefined
        }
    >
        <Modal.Section>
            <div className='downgradeFeedbackModal'>
                <BlockStack gap="400">
                    <BlockStack gap="200">
                        {
                            isLongerDowngrade ? (
                                <div className='thankYouCard'>
                                    <div className='thankYouCardIcon'>
                                        <Icon source={HeartIcon} />
                                    </div>
                                    <div className='thankYouCardText'>
                                        <Text as="p" fontWeight="semibold">
                                            {t("Thank You for Being with Us")}
                                        </Text>
                                        <Text as="p" tone="subdued">
                                            {t("Your data is saved — you can come back anytime.")}
                                        </Text>
                                    </div>
                                </div>
                            ) : null
                        }
                        <Text as="p" fontWeight="medium">
                            {isLongerDowngrade
                                ? t("Here's how your plan will change on the free tier")
                                : t("Here's what's included in your free plan")}:
                        </Text>
                        <div className='freePlanBenefits'>
                            {
                                freePlanBenefits.map((item, idx) => (
                                    <div className='freePlanBenefitItem' key={idx}>
                                        <div className='freePlanBenefitInfo'>
                                            <div className='freePlanBenefitIcon'>
                                                <Icon source={item.icon} tone="base" />
                                            </div>
                                            <div className='freePlanBenefitText'>
                                                <Text as="p" fontWeight="medium">{item.title}</Text>
                                                {item.subtitle ? ((idx === 0 && !(downDataCompare?.un_opt_num)) || (idx === 1 && !(downDataCompare?.pages_audited)) || (idx === 2 && !(downDataCompare?.ai_credit))) ? null : (
                                                    <Text as="p" variant="bodySm" tone="subdued">{item.subtitle}</Text>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className='freePlanBenefitChange'>
                                            <div className='freePlanBenefitOld'>
                                                <span className='oldVal'>{item.oldVal}</span>
                                                <span className='oldUnit'>{item.oldUnit}</span>
                                            </div>
                                            <div className='freePlanBenefitArrow'>
                                                <Icon source={ArrowRightIcon} tone="subdued" />
                                            </div>
                                            <div className='freePlanBenefitNew'>
                                                <span className='newVal'>{item.newVal}</span>
                                                <span className='newUnit'>{item.newUnit}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </BlockStack>
                    <BlockStack gap="200">
                        <Text as="p" fontWeight="medium">
                            {t("What would bring you back? (optional)")}
                        </Text>
                        <TextField
                            id="feedbackVal"
                            multiline={3}
                            placeholder={t("Tell us what you liked or what we can improve")}
                            value={feedbackVal}
                            onChange={(value) => setFeedbackVal(value)}
                            autoComplete="off"
                        />
                    </BlockStack>
                </BlockStack>
            </div>
        </Modal.Section>
    </Modal>


    // 选择 expensive / other 弹窗  || 选择Too difficult to figure it out 
    const isDiscountType = ['expensive', 'other'].includes(continueVal);
    const isResultsAltType = ['results', 'alternative'].includes(continueVal);
    const isDifficultType = continueVal === 'difficult';
    const isFeaturesType = continueVal === 'features';
    const secondaryBtnText = isDiscountType
        ? t("Yes, please!")
        : isFeaturesType
            ? t("Submit feedback")
            : t("Get my plan");

    const secondaryBtnAction = isDiscountType
        ? handleApplyDiscountCode
        : handleContactUs;
    const discountHalfModal = <Modal
        open={['expensive', 'other', 'difficult'].includes(continueVal) || (['results', 'features', 'alternative'].includes(continueVal) && Boolean(coupon_claimed))}
        onClose={handleCloseFeedModal}
        title={''}
        titleHidden
    >
        <div className='discountHalfModal'>
            <div className='discountHalfModalImg'>
                <img src={
                    `/imgs/pricing/retain/${isDiscountType ? 'expensive' :
                        isDifficultType ? 'difficult' :
                            isResultsAltType ? 'has_dis_result' :
                                isFeaturesType ? 'has_dis_feature' : 'expensive'}.png`
                } alt='' />
            </div>
            <div className='discountHalfModalContent'>
                <BlockStack gap="600" inlineAlign="center">
                    <BlockStack gap="200" inlineAlign="center">
                        <Text variant="headingLg" as="h2" alignment="center">
                            {
                                isDiscountType ? t("50% off for the next 3 months?") :
                                    isDifficultType ? t("Too complicated? We'll set it up with you.") :
                                        isResultsAltType ? t("Get your free SEO action plan") :
                                            isFeaturesType ? t("What feature are you missing?") : ""
                            }
                        </Text>
                        <div className='discountHalfDesc'>
                            <Text as="p" alignment="center" tone="subdued">
                                {
                                    isDiscountType ? t("How about staying on current [{{v1}}] plan at just ${{v2}}/month for the next 3 months? Keep your SEO progress going at half the price.", downgradeLevel === 3 ? "Pre" : "Pro", downgradeLevel === 3 ? 29.99 : 14.99) :
                                        isDifficultType ? t("Our SEO specialist will walk you through everything step by step and help you get results faster.") :
                                            ['results'].includes(continueVal) ? t("We'll find out why your traffic isn't growing and send you a clear action plan") :
                                                ['alternative'].includes(continueVal) ? t("Switching tools won't fix your traffic — we'll show you what's blocking it and how to fix it.") :
                                                    isFeaturesType ? t("Tell us what you're looking for — we'll prioritize it and notify you as soon as it's ready.") : ""
                                }
                            </Text>
                        </div>
                    </BlockStack>
                    <ButtonGroup>
                        <Button
                            disabled={disBtnLoading}
                            loading={paidLoading}
                            onClick={handleCancelAnyway}
                        >
                            {isDiscountType ? t("No, cancel anyway") : t("Cancel anyway")}
                        </Button>
                        <Button
                            variant="primary"
                            disabled={paidLoading}
                            loading={isDiscountType ? disBtnLoading : false}
                            onClick={secondaryBtnAction}
                        >
                            {isDifficultType ? t("Get help 1-on-1") : secondaryBtnText}
                        </Button>
                    </ButtonGroup>
                </BlockStack>
            </div>
        </div>
    </Modal>

    // 选择 Didn't see results || 选择 Missing features || 选择 Found a better alternative
    const didntResultsModal = <Modal
        open={['results', 'features', 'alternative'].includes(continueVal) && !Boolean(coupon_claimed)}
        onClose={handleCloseFeedModal}
        title={
            continueVal === 'results' ? t("Before you go, don't lose your SEO progress") :
                continueVal === 'features' ? t("Help us build what you need") :
                    continueVal === 'alternative' ? t("Before you switch, see what's holding your traffic back") : ''
        }
        secondaryActions={
            [
                {
                    content: t("Cancel anyway"),
                    onAction: handleCancelAnyway,
                    disabled: disBtnLoading,
                    loading: paidLoading,
                }
            ]}
    >
        <Modal.Section>
            <div className='didntSeeResultsModalContent'>
                <BlockStack gap="400">
                    <div className='didntSeeResultsBanner'>
                        <img src={`/imgs/pricing/retain/${continueVal !== 'features' ? 'get_action' : 'get_feature'}.png`} alt='' />
                        <div className='didntSeeResultsBannerInfo'>
                            <BlockStack gap="100">
                                <Text variant="headingSm" as="h3">
                                    {continueVal !== 'features' ? t("Get your free SEO action plan") : t("What feature are you missing?")}
                                </Text>
                                <Text as="p" tone="subdued">
                                    {
                                        ['results'].includes(continueVal) ? t("We'll find out why your traffic isn't growing and send you a clear action plan") :
                                            ['alternative'].includes(continueVal) ? t("Switching tools won't fix your traffic — we'll show you what's blocking it and how to fix it.") : t("Tell us what you're looking for — we'll prioritize it and notify you as soon as it's ready.")
                                    }
                                </Text>
                            </BlockStack>
                            <div className='didntSeeResultsBannerAction'>
                                <Button variant="primary" size="medium" onClick={handleContactUs}>
                                    {continueVal === 'features' ? t("Submit feedback") : t("Get my plan")}
                                </Button>
                            </div>
                        </div>
                    </div>

                    <BlockStack gap="200">
                        <Text as="p" tone="subdued">
                            {t("Or, try this instead")}
                        </Text>
                        <div className='didntSeeResultsAlt'>
                            <div className='didntSeeResultsAltIcon'>
                                <img src='/imgs/pricing/retain/gift50.png' alt='' />
                            </div>
                            <div className='didntSeeResultsAltInfo'>
                                <BlockStack gap="050">
                                    <Text variant="headingSm" as="h3">
                                        {t("Stay and save 50%")}
                                    </Text>
                                    <Text as="p" tone="subdued">
                                        {
                                            continueVal === 'results' ? t("Keep improving your SEO results at half the cost.") :
                                                continueVal === 'features' ? t("Missing a feature? Stay at 50% off while we work on it.") :
                                                    continueVal === 'alternative' ? t("Stay at 50% off and see real improvements before you decide.") : ''
                                        }
                                    </Text>
                                </BlockStack>
                            </div>
                            <div className='didntSeeResultsAltAction'>
                                <Button size="medium" disabled={paidLoading} loading={disBtnLoading} onClick={handleApplyDiscountCode}>
                                    {t("Save 50%")}
                                </Button>
                            </div>
                        </div>
                    </BlockStack>
                </BlockStack>
            </div>
        </Modal.Section>
    </Modal >

    // 选择 Subscribed by mistake 
    const mistakeIssueList = [
        t("Charged after cancelling a free trial"),
        t("Enrolled in annual billing by mistake"),
        t("Extra credit charges on your subscription"),
        t("Amount doesn't match your expected price"),
        t("Other billing issues"),
    ];
    const subscribedByMistakeModal = <Modal
        open={continueVal === 'mistake'}
        title={t("Let's fix this billing issue first")}
        primaryAction={{
            content: t("Get help with billing"),
            onAction: handleContactUs,
            disabled: paidLoading,
        }}
        secondaryActions={{
            content: t("Cancel anyway"),
            onAction: handleCancelAnyway,
            disabled: disBtnLoading,
            loading: paidLoading,
        }}
        onClose={handleCloseFeedModal}
    >
        <Modal.Section>
            <div className='subscribedByMistakeContent'>
                <BlockStack gap="400">
                    <Text as="p" tone="subdued">
                        {t("Please contact us before canceling. We'll review your billing issue within 1 business day and resolve it if eligible, including refunds.")}
                    </Text>
                    <BlockStack gap="200">
                        <Text variant="headingSm" as="h3">
                            {t("Common issues we can help with")}:
                        </Text>
                        <div className='mistakeIssueList'>
                            {
                                mistakeIssueList.map((item, idx) => (
                                    <div className='mistakeIssueItem' key={idx}>
                                        <span className='mistakeIssueIcon'>
                                            <Icon source={CheckCircleIcon} tone="success" />
                                        </span>
                                        <Text as="span" tone="subdued">{item}</Text>
                                    </div>
                                ))
                            }
                        </div>
                    </BlockStack>
                </BlockStack>
            </div>
        </Modal.Section>
    </Modal>

    // 降级弹窗
    const o_state = openState && !continueVal && !showFeedback;
    const downgradeModal = <Modal
        open={o_state}
        title={t("Sorry to see you go")}
        onClose={handleCloseSeeyouModal}
        primaryAction={{
            content: t("Continue to Cancel"),
            onAction: handleContinueToCancel,
            disabled: selectVal.length === 0,
            loading: paidLoading,
        }}
        secondaryActions={{
            content: t("Keep my subscription"),
            onAction: handleCloseSeeyouModal,
            disabled: paidLoading,
        }}
    >
        <Modal.Section>
            <div className='downgradeModalContent'>
                <BlockStack gap={400}>
                    <Text variant="headingMd" as="h2"><span style={{ color: '#d72c0d' }}>*</span> {t("Why are you cancelling?")}</Text>
                    <BlockStack gap={200}>
                        <ChoiceList
                            title=""
                            choices={[
                                { label: t("Too expensive"), value: 'expensive' },
                                { label: t("Didn't see results (e.g. no improvement in traffic or sales)"), value: 'results' },
                                { label: t("Subscribed by mistake (e.g. unexpected charge)"), value: 'mistake' },
                                { label: t("No longer or temporarily not needed (e.g. store closed)"), value: 'longer' },
                                { label: t("Too difficult to figure it out"), value: 'difficult' },
                                { label: t("Missing features or technical issues"), value: 'features' },
                                { label: t("Found a better alternative"), value: 'alternative' },
                                { label: t("Other"), value: 'other' },
                            ]}
                            selected={selectVal}
                            disabled={paidLoading}
                            onChange={(value) => { setSelectVal(value) }}
                        />
                        {
                            selectVal.includes('other') ? <TextField
                                id="otherVal"
                                placeholder={t("Please share your reason — it helps us improve")}
                                value={otherVal}
                                onChange={handleInputChange}
                                disabled={paidLoading}
                                error={otherValError ? t("The input field cannot be empty") : ''}
                            /> : null
                        }
                    </BlockStack>
                </BlockStack>
            </div>
        </Modal.Section>
    </Modal>;

    // 降级模块
    const downgradeModule = <div className='downgradeModule'>
        {downgradeModal}
        {discountHalfModal}
        {didntResultsModal}
        {subscribedByMistakeModal}
        {downgradeFeedbackModal}
    </div>

    return downgradeModule;
};

export default DowngradeRetain;